<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div v-if="error" class="alert alert-danger" style="margin-bottom:10px">{{ error }}</div>
        <div v-if="message" class="alert alert-success" style="margin-bottom:10px">{{ message }}</div>
      </div>
    </div>
    <div class="row no-gutters months-nav">
      <div class="col-3 col-sm-2">
        <button v-shortkey.once="['arrowleft']" class="btn btn-secondary" @click="selectPreviousMonth()" @shortkey="selectPreviousMonth"><i class="pe pe-chevron-left" aria-hidden="true"/></button>
      </div>
      <div class="col text-center">
        {{ month }}
      </div>
      <div class="col-3 col-sm-2">
        <button v-shortkey.once="['arrowright']" class="btn btn-secondary" @click="selectNextMonth()" @shortkey="selectNextMonth"><i class="pe pe-chevron-right" aria-hidden="true"/></button>
      </div>
    </div>
    <div v-if="totalRequiredFunds || totalMonthPayment" class="row">
      <div class="col text-left ledger-summary">

        <div class="row">
          <div v-if="!isPastMonth && totalRequiredFunds" :class="{'col-4': totalRequiredFunds && totalMonthPayment, 'col-12': totalRequiredFunds && !totalMonthPayment}" class="ledger-summary-one text-center">
            <h5 class="text-yellow">Required</h5>
            <span class="ledger-summary-amount text-yellow">{{ totalRequiredFunds | formatNumber }} {{ state.ledger.selectedLedger.currency | uppercase }}</span>
          </div>
          <div v-if="totalMonthPayment || isPastMonth" :class="{'col-4': totalMonthPayment, 'col-12': isPastMonth || (!isPastMonth && !totalRequiredFunds)}" class="ledger-summary-one text-center">
            <h5 class="text-green">Spent</h5>
            <span class="ledger-summary-amount text-green">{{ totalMonthPayment | formatNumber }} {{ state.ledger.selectedLedger.currency | uppercase }}</span>
          </div>
          <div v-if="!isPastMonth && totalMonthPayment && totalRequiredFunds" class="col-4 ledger-summary-one ledger-bt text-center">
            <h5 class="font-weight-bold">Total</h5>
            <span class="ledger-summary-amount">{{ totalRequiredFunds + totalMonthPayment | formatNumber }} {{ state.ledger.selectedLedger.currency | uppercase }}</span>
          </div>
        </div>

      </div>
    </div>
    <div v-for="(expenseGroup, date) in list" :key="date" class="expense-group">
      <div class="row bg-green text-green px-1">
        <div class="col-12 font-weight-bold expense-group-head">{{ date | formatDateDayMonth }}</div>
      </div>
      <div v-for="(expenseOccurrence) in expenseGroup" :key="expenseOccurrence.id" class="row no-gutters text-green py-2 px-1">
        <div :class="{'col-4 col-md-6': expenseOccurrence.requiredFunds && !isPastMonth, 'col-7 col-md-8': !expenseOccurrence.requiredFunds || isPastMonth}">
          <span>
            <edit-expense :key="'expense-' + expenseOccurrence.id" :expense-occurrence="expenseOccurrence">
              {{ expenseOccurrence.label }}
            </edit-expense>
            <b-badge v-b-tooltip.hover v-if="expenseOccurrence.payment > expenseOccurrence.estimate" :title="'Initial estimate: ' + expenseOccurrence.estimate + ' ' + state.ledger.selectedLedger.currency" class="expense-estimate-warning" variant="warning">!</b-badge>
          </span>
        </div>
        <div v-if="expenseOccurrence.requiredFunds && !isPastMonth" class="col-3 col-md-2 text-right text-yellow"><span>{{ expenseOccurrence.requiredFunds | formatNumber }}</span></div>
        <div class="col-3 col-md-2 text-right">{{ expenseOccurrence.payment | formatNumber }}</div>
        <div class="col-2 add-payment">
          <payment :key="expenseOccurrence.id" :expense-id="expenseOccurrence.id" :expense-label="expenseOccurrence.label" :records="state.ledger.selectedLedger.payments[expenseOccurrence.id]"/>
        </div>
      </div>
    </div>
    <div class="row"><br><br></div>
    <div class="ledger-jump-to-current-month-floating-button-container">
      <button v-shortkey.once="['ctrl', 't']"
              v-if="(monthViewOffset < -1 || monthViewOffset > 1) &&
                state.account.me &&
              !state.ui.modalOpen"
              class="btn btn-lg btn-success ledger-jump-to-current-month-floating-button"
              @click="jumpToCurrentMonth" @shortkey="jumpToCurrentMonth"
      >
        <i v-if="monthViewOffset < -1" aria-hidden="true" class="pe pe-chevron-left"/> current month <i v-if="monthViewOffset > 1" aria-hidden="true" class="pe pe-chevron-right"/>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Payment from './Payment'
import EditExpense from './EditExpense'
let _ = require('lodash')
let moment = require('moment')

export default {
  components: {
    'payment': Payment,
    'editExpense': EditExpense
  },
  props: {
    expenseOccurrences: {
      required: true
    }
  },
  data () {
    return {
      error: '',
      message: '',
      startDate: moment().startOf('month').format('YYYY-MM-DD'),
      endDate: moment().endOf('month').format('YYYY-MM-DD'),
      totalRequiredFunds: 0,
      totalMonthEstimate: 0,
      totalMonthPayment: 0
    }
  },
  computed: {
    ...mapState({
      state: state => state
    }),
    month () {
      let date = moment(this.startDate).format('MMMM YYYY')
      this.$eventHub.$emit('selected-ledger-month-view-change', this.startDate)
      return date
    },
    isPastMonth () {
      return (moment(this.startDate).format('YYYY-MM') < moment().format('YYYY-MM'))
    },
    monthViewOffset () {
      return moment().startOf('month').diff(this.startDate, 'month')
    },
    list () {
      let self = this
      let list = {}
      let totalEstimate = 0
      let totalPayment = 0
      let totalRequiredFunds = 0

      /**
       * This little hack is for making the list computed property
       * not dependable from the endDate data attribute.
       * Depending form the endDate attribute would trigger twice
       * this list generation.
       */
      let endDate = moment(self.startDate).endOf('month').format('YYYY-MM-DD')

      _.forEach(this.expenseOccurrences, function (expenseOccurrence) {
        if (expenseOccurrence.date >= self.startDate && expenseOccurrence.date <= endDate) {
          if (!list.hasOwnProperty(expenseOccurrence.date) && !expenseOccurrence.is_not_day_specific) {
            list[expenseOccurrence.date] = []
          }
          if (!list.hasOwnProperty(0) && expenseOccurrence.is_not_day_specific) {
            list[0] = []
          }

          let key = expenseOccurrence.is_not_day_specific ? 0 : expenseOccurrence.date
          let payment = self.sumExpensePayments(self.state.ledger.selectedLedger.payments[expenseOccurrence.id])
          let isPaid = Number(payment) >= Number(expenseOccurrence.estimate)
          let requiredFunds = expenseOccurrence.estimate - payment

          totalEstimate = totalEstimate + expenseOccurrence.estimate
          totalPayment = totalPayment + payment

          list[key].push({
            id: expenseOccurrence.id,
            date: expenseOccurrence.date,
            createdBy: expenseOccurrence.created_by,
            expenseId: expenseOccurrence.expense_id,
            label: expenseOccurrence.label,
            estimate: expenseOccurrence.estimate,
            isRecurring: expenseOccurrence.is_recurring,
            recurringFrequency: expenseOccurrence.recurring_frequency,
            recurringFrequencyInterval: expenseOccurrence.recurring_frequency_interval,
            recurringEnds: expenseOccurrence.recurring_ends,
            recurringOccurrences: expenseOccurrence.recurring_occurrences,
            recurringEndDate: expenseOccurrence.recurring_end_date,
            isNotDaySpecific: expenseOccurrence.is_not_day_specific,
            payment: payment,
            requiredFunds: requiredFunds > 0 ? requiredFunds : 0,
            isPaid: isPaid
          })

          if (!isPaid) {
            totalRequiredFunds = totalRequiredFunds + (expenseOccurrence.estimate - payment)
          }
        }
      })

      this.setTotalMonthEstimate(totalEstimate)
      this.setTotalMonthPayment(totalPayment)
      this.setTotalRequiredFunds(totalRequiredFunds)

      return list
    }
  },
  methods: {
    clearNotifications () {
      this.error = ''
      this.message = ''
    },
    selectPreviousMonth () {
      let currentReferenceDate = this.startDate
      this.startDate = moment(currentReferenceDate).subtract(1, 'month').startOf('month').format('YYYY-MM-DD')
      this.endDate = moment(currentReferenceDate).subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
      this.clearNotifications()
    },
    selectNextMonth () {
      let currentReferenceDate = this.startDate
      this.startDate = moment(currentReferenceDate).add(1, 'month').startOf('month').format('YYYY-MM-DD')
      this.endDate = moment(currentReferenceDate).add(1, 'month').endOf('month').format('YYYY-MM-DD')
      this.clearNotifications()
    },
    sumExpensePayments (payments) {
      let total = 0
      _.forEach(payments, function (payment) {
        total = total + payment.amount
      })

      return total
    },
    setTotalMonthEstimate (value) {
      this.totalMonthEstimate = value
    },
    setTotalMonthPayment (value) {
      this.totalMonthPayment = value
    },
    setTotalRequiredFunds (value) {
      this.totalRequiredFunds = value
    },
    jumpToCurrentMonth () {
      this.startDate = moment().startOf('month').format('YYYY-MM-DD')
      this.endDate = moment().endOf('month').format('YYYY-MM-DD')
      this.clearNotifications()
    }
  }
}
</script>

<style>
  .ledger-jump-to-current-month-floating-button {
    z-index: 9999;
  }
  .months-nav .pe {
    margin-right:0!important;
  }
</style>
